import { getSignerDisplayNames, ISignerResponse } from '../../../../../../types/signingAppointment/ISignerResponse';
import { PencilSquareIcon, HomeIcon } from '@heroicons/react/24/outline';
import { BodyTextTW, BoldBodyTextTW } from '../../../../../../tailwindComponents/bodyText/BodyTextTW';
import { TextButtonTW } from '../../../../../../tailwindComponents/buttonTW/TextButtonTW';
import React from 'react';
import { formatPhoneNumber } from '../../../../../../utilities/shared/formatPhoneNumber';
import { Show } from '../../../../../shared/Show';

export interface SignerItemProps {
  signer: ISignerResponse;
  onEditSigner: (signer: ISignerResponse) => void;
  canEdit: boolean;
}

export const SignerItem = ({ signer, onEditSigner, canEdit }: SignerItemProps) => {
  const onEditSignerClick = () => {
    onEditSigner(signer);
  };

  return (
    <div className={'p-2'}>
      <div className={'flex justify-start'}>
        <HomeIcon className={'mr-1 h-5 w-5'} />
        <BoldBodyTextTW>{getSignerDisplayNames(signer)}</BoldBodyTextTW>
        <Show when={canEdit}>
          <PencilSquareIcon onClick={onEditSignerClick} className={'ml-3 h-5 w-5 cursor-pointer'} />
        </Show>
      </div>
      <div className={'ml-6'}>
        <BodyTextTW>
          {'email: '}
          <TextButtonTW>{signer.email}</TextButtonTW>
        </BodyTextTW>
        <BodyTextTW>phone: {formatPhoneNumber(signer.phoneNumber ?? '')}</BodyTextTW>
      </div>
    </div>
  );
};
